import { CardActions } from '@mui/material';
import React, { useContext } from 'react';
import { ExportButton, List, Pagination, PaginationActions } from 'react-admin';
import { ReadOnlyContext } from './context/ReadOnlyContext';

const ReadOnlyActions = () => (
    <CardActions>
        <ExportButton />
    </CardActions>
);

const LS_SW_LIST_ROWS_PER_PAGE = 'sw-list-rowsPerPage';

const SwPaginationActions = (props) => {
    const { rowsPerPage } = props;
    localStorage.setItem(LS_SW_LIST_ROWS_PER_PAGE, rowsPerPage);
    return <PaginationActions {...props} />;
};
const SwPagination = (props) => (
    <Pagination {...props} ActionsComponent={SwPaginationActions} />
);

export const SwList = (props) => {
    const readonly = useContext(ReadOnlyContext) || false;
    let rowsPerPage = 10;
    const strRowsPerPage = localStorage.getItem(LS_SW_LIST_ROWS_PER_PAGE);

    if (strRowsPerPage) {
        rowsPerPage = parseInt(strRowsPerPage);
    }

    return (
        <List
            {...props}
            perPage={rowsPerPage}
            pagination={<SwPagination />}
            actions={readonly ? <ReadOnlyActions /> : undefined}
        >
            {props.children}
        </List>
    );
};
